import axios from 'axios';

let API_URL;
if (process.env.REACT_APP_DEV==='dev') {
  API_URL = process.env.REACT_APP_API_URL;
} else {
  API_URL = process.env.REACT_APP_API_BACKEND_URL;
}



/**
 * Kullanıcının bildirimlerini getirir
 * @param {Object} params - Filtre parametreleri
 * @param {number} params.page - Sayfa numarası (varsayılan: 1)
 * @param {number} params.limit - Sayfa başına bildirim sayısı (varsayılan: 10)
 * @param {boolean} params.unread - Sadece okunmamış bildirimleri getirmek için
 * @returns {Promise<Object>} - Bildirim verileri
 */
export const getNotifications = async (params = {}) => {
  const { page = 1, limit = 10, unread = false } = params;
  
  try {
    const response = await axios.get(`${API_URL}/notifications`, {
      params: { page, limit, unread: unread ? 'true' : undefined }
    });
    
    return response.data;
  } catch (error) {
    console.error('Bildirimler alınırken hata:', error);
    throw error;
  }
};

/**
 * Okunmamış bildirim sayısını getirir
 * @returns {Promise<number>} - Okunmamış bildirim sayısı
 */
export const getUnreadNotificationCount = async () => {
  try {
    const response = await axios.get(`${API_URL}/notifications/unread-count`);
    return response.data.unreadCount;
  } catch (error) {
    console.error('Bildirim sayısı alınırken hata:', error);
    throw error;
  }
};

/**
 * Bildirimi okundu olarak işaretler
 * @param {string} id - Bildirim ID
 * @returns {Promise<Object>} - Güncellenmiş bildirim verisi
 */
export const markNotificationAsRead = async (id) => {
  try {
    const response = await axios.put(`${API_URL}/notifications/${id}/mark-read`, {});
    return response.data;
  } catch (error) {
    console.error('Bildirim okundu olarak işaretlenirken hata:', error);
    throw error;
  }
};

/**
 * Tüm bildirimleri okundu olarak işaretler
 * @returns {Promise<Object>} - Sonuç verisi
 */
export const markAllNotificationsAsRead = async () => {
  try {
    const response = await axios.put(`${API_URL}/notifications/mark-all-read`, {});
    return response.data;
  } catch (error) {
    console.error('Tüm bildirimler okundu olarak işaretlenirken hata:', error);
    throw error;
  }
};

/**
 * Bildirimi siler
 * @param {string} id - Bildirim ID
 * @returns {Promise<Object>} - Sonuç verisi
 */
export const deleteNotification = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error('Bildirim silinirken hata:', error);
    throw error;
  }
};

/**
 * Yeni bildirim oluşturur (Sadece Admin rolü için)
 * @param {Object} notificationData - Bildirim verileri
 * @returns {Promise<Object>} - Oluşturulan bildirim verisi
 */
export const createNotification = async (notificationData) => {
  try {
    const response = await axios.post(`${API_URL}/notifications`, notificationData);
    return response.data;
  } catch (error) {
    console.error('Bildirim oluşturulurken hata:', error);
    throw error;
  }
}; 